<!--Banner Start-->
<div class="row banner">
  <div class="col-md-12">
    <ngb-carousel class="ng_cls" [interval]="3000">
      <ng-template ngbSlide>
        <img src="assets/images/slider8.jpg" alt="Random slide" style="width: 100%; height: 100%; object-fit: cover">
        <div class="carousel-caption">
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <img src="assets/images/slider9.jpg" alt="Random slide" style="width: 100%; height: 100%; object-fit: cover">
        <div class="carousel-caption">
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <img src="assets/images/slider1.jpg" alt="Random slide" style="width: 100%; height: 100%; object-fit: cover">
        <div class="carousel-caption">
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <img src="assets/images/slider2.jpg" alt="Random slide" style="width: 100%; height: 100%; object-fit: cover">
        <div class="carousel-caption">
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <img src="assets/images/slider3.jpg" alt="Random slide" style="width: 100%; height: 100%; object-fit: cover">
        <div class="carousel-caption">
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <img src="assets/images/slider4.jpg" alt="Random slide" style="width: 100%; height: 100%; object-fit: cover">
        <div class="carousel-caption">
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <img src="assets/images/slider5.jpg" alt="Random slide" style="width: 100%; height: 100%; object-fit: cover">
        <div class="carousel-caption">
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <img src="assets/images/slider6.jpg" alt="Random slide" style="width: 100%; height: 100%; object-fit: cover">
        <div class="carousel-caption">
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <img src="assets/images/slider7.jpg" alt="Random slide" style="width: 100%; height: 100%; object-fit: cover">
        <div class="carousel-caption">
        </div>
      </ng-template>
      

    </ngb-carousel>

  </div>
</div>
<!--Banner End-->
<div class="container">

  <div class="row notifi_main ">
    <div class="col-md-12">
      <span onmouseover="mar.stop();" onmouseout="mar.start();" class="notfication_cls">
        Notification
      </span>
      <!-- CBT Exams are sheduled till 10th April, for detailed shedule contact your state controller of Examination, -->
      <marquee id="mar" width="100%" direction="left" onmouseover="mar.stop();" onmouseout="mar.start();">
        <h1><b style="color: red;">CBT fee payment link for Supplementary exam will be enable in NCVT MIS portal </b></h1>
        <!-- Last day of CBT fee payment is extended till 11th August Midnight | Fee link for annual supplementary candidates (for batch of 2018-19, 2018-20, 2019-20 & 2019-21) shall be opened separately | RPL Supplementary Exam Registration - <a
          href="https://nimionlineadmission.in/rplexam2/" target="_blank"> Click Here </a> -->
      </marquee>
    </div>
  </div>

</div>

<section class="section_box_one">
  <div class="container">
    <h2>About Our Online CBT Examination system</h2>
    <h1><p>CBT fee payment link for Supplementary exam will be enable in NCVT MIS portal</p></h1>
    <div class="row">
      <div class="col-md-4">
        <h3>CBT</h3>
        <p>
          CBT – 100 Marks – as per guidelines, Duration: 1 ½ hours , Topic for CBT Training Methodology, Employability Skills, Workshop Calculation & Science in the ratio of 20:20:10 and Total questions – 50 with each 2 marks </p>


      </div>
      <div class="col-md-4">
        <h3>Guidelines</h3>
        <p>
          Use safe exam browser application for live exam
        </p>
        <p> <a href="https://safeexambrowser.org/download_en.html" target="_blank"> Click here to Download and Install
            Safe Exam Browser</a></p>
        <p> <a href="https://nimionlinetesting.in/aitt_exam/SebClientSettingsnewforsession.seb"> If already Installed
            click here to download Configuration file </a></p>
      </div>
      <div class="col-md-4">
        <h3>Mock Test</h3>
        <p>
          A Mock test of the actual CBT interface in provided to the students for getting familiarized with the system.
        </p>
        <p>Students can use the following mock test user id and password to access the same <a class="click_here" href="https://www.nimionlinetesting.in/aitt_exam/" target="_blank">
            Click here</a>
        </p>
      </div>
    </div>

    
  </div>
</section>

<hr>

<h1 style="text-align: center;">  
   Upcoming CBT Exam
</h1>

<!--Content Start-->
<section class="section_box_one">
  <div class="container">
    <h2>Flexi-MoU Centurion University CBT Exam</h2>
    <div class="row">
      <div class="col-md-4">
        <h3>Examination Topic</h3>
        <p>
          Related to the subjects </p>
      </div>

      <div class="col-md-4">
        <h3>Date of Exam Scheduled</h3>
        <p>
          CBT Exam is scheduled for 4-12-2021 to 6-12-2021</p>
      </div>      
     
      <div class="col-md-4">
        <h3>More Details</h3>

        <p>
          will be announced shortly
           
         </p>

       
      </div>
    </div>

    
  </div>
</section>
<!--Content End-->

<!--Content Start-->
<section class="section_box_one">
  <div class="container">
    <h2>IBM Advanced Diploma CBT Exams</h2>
    <div class="row">
      <div class="col-md-4">
        <h3>Examination Topic</h3>
        <p>
          Related to IBM Advanced diploma subjects </p>
      </div>

      <div class="col-md-4">
        <h3>Date of Exam Scheduled</h3>
        <p>
          CBT Exam is scheduled for 6-12-2021 to 14-12-2021</p>
      </div>      
     
      <div class="col-md-4">
        <h3>More Details</h3>

        <p>
          will be announced shortly
           
         </p>

       
      </div>
    </div>

    
  </div>
</section>
<!--Content End-->

<!--Content Start-->
<section class="section_box_one">
  <div class="container">
    <h2>All India Trade Test of Craft Instructors under CITS Regular/Supplementary exam in the month of November 2021</h2>
    <div class="row">
      <div class="col-md-4">
        <h3>Examination Topic</h3>
        <p>
          CBT examination of Theoretical subjects (Trade Theory-I,II, Trade Skill-I,II, Workshop Calculation & Science, Workshop Calculation, Workshop Science, Vocational Science & Calculation, Soft Skill & English Communication and Training Methodology </p>
      </div>

      <div class="col-md-4">
        <h3>Date of Exam Scheduled</h3>
        <p>
          CBT Exam is scheduled for 23-11-2021 to 28-11-2021</p>
      </div>      
     
      <div class="col-md-4">
        <h3>More Details</h3>

        <p>
          For More Details CITS <a routerLink="/aboutcbt">Click here</a>
           
         </p>

        <p>
         For More Exam Details <a target="_blank" href="assets/pdf/ScannerGo_23Oct2021_543210.pdf">Click here</a>
          
        </p>
        <p>For Hall Ticket download <a target="_blank" href="https://nimionlineadmission.in/2020halltickets/">Click here</a> </p>
        <p>Hall tickets for left over candidates <a target="_blank" href="https://nimionlineadmission.in/2020halltickets_v2/">Click here</a> </p>
        <p>CBT exams for leftover candidates scheduled from 29th November to 01st December 2021</p>
      </div>
    </div>

    
  </div>
</section>
<!--Content End-->










<!-- <section class="section_box_one">
  <div class="container">
    <h2>All India Trade Test 2020 - Computer Based Test</h2>
    <div class="row">
      <div class="col-md-4">
        <h3>Online Examinations</h3>
        <p>
          AITT exam are being conducted online for all ITI students in two shift per day. </p>
        <p>The theory exam comprises of 60 questions for Non - Engineering trades & Engineering second year trades and
          80 questions for Engineering trades. <span class="click_here" routerLink="/aboutcbt"
            routerLinkActive="active"> Read More</span>
        </p>

      </div>
      <div class="col-md-4">
        <h3>Guidelines</h3>
        <p>
          Use safe exam browser application for live exam
        </p>
        <p> <a href="https://safeexambrowser.org/download_en.html" target="_blank"> Click here to Download and Install
            Safe Exam Browser</a></p>
        <p> <a href="https://nimionlinetesting.in/aitt_exam/SebClientSettingsnewforsession.seb"> If already Installed
            click here to download Configuration file </a></p>
      </div>
      <div class="col-md-4">
        <h3>Mock Test</h3>
        <p>
          A Mock test of the actual CBT interface in provided to the students for getting familiarized with the system.
        </p>
        <p>Students can use the following mock test user id and password to access the same <span class="click_here">
            Click here</span>
        </p>
      </div>
    </div>
  </div>
</section> -->
<!--Content End-->

<!--Content Start-->
<section class="section_box_one">
  <div class="container">
    <h2>CITS - RPL Exam Supplementary </h2>
    <div class="row">
      <div class="col-md-4">
        <h3>Online Examinations</h3>
        <p> Cits supplementary RPL CBT exam will be conducted for trade theory wsc and training methodology online in the following examination center  </p>
        <p>The theory exam comprises of 60 questions for Non - Engineering trades & Engineering second year trades and
          80 questions for Engineering trades. <span class="click_here" routerLink="/aboutcbt"
            routerLinkActive="active"> Read More</span>
        </p>

      </div>
      <div class="col-md-4">
        <h3>Guidelines For Exam Center </h3>
        <p>
          Use safe exam browser application for live exam
        </p>
        <p> <a href="https://safeexambrowser.org/download_en.html" target="_blank"> Click here to Download and Install
            Safe Exam Browser</a></p>
        <p> <a href="https://nimionlinetesting.in/aitt_exam/SebClientSettingsnewforsession.seb"> If already Installed
            click here to download Configuration file </a></p>
      </div>
      <div class="col-md-4">
        <h3>Mock Test</h3>
        <p>
          A Mock test of the actual CBT interface in provided to the students for getting familiarized with the system.
        </p>
        <p>Students can use the following mock test user id and password to access the same <span class="click_here">
            Click here</span>
        </p>
      </div>
    </div>
  </div>
</section>
<!--Content End-->


<!--Content Start-->
<section class="section_box_two">
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <h3> {{ isLoading$ | async }}</h3>
        <p class="counter">
          Phases
        </p>
      </div>

      <div class="col-md-3">
        <h3>{{ isLoading_2 | async }}</h3>
        <p class="counter">
          Exam Centers
        </p>
      </div>

      <div class="col-md-3">
        <h3 class="counter">
          {{ isLoading_3 | async }}
        </h3>
        <p>Candidates Allotted</p>

      </div>

      <div class="col-md-3">
        <h3> {{ isLoading_4 | async }} </h3>
        <p class="counter">
          Exam Attended
        </p>
      </div>

    </div>
  </div>
</section>
<!--Content End-->


<!--Content Start-->



<section class="section_box_one">
  <div class="container">
    <div class="row">
      <div>
        <h3>Upcoming CBT Exams</h3>

      </div>
      <div style="display: block; width: 100%">
        <h5>will be announced shortly</h5>

      </div>
      <!-- <div class="col-md-12">
            <h3>Upcoming CBT Exams</h3>
            <table>
              <thead>
                  <th>S.No</th>
                  <th>Date</th>
                  <th>Exams</th>
              </thead>

              <tr>
                <td>1</td>
                <td>27/3/2021</td>
                <td>First year and outgoing batches of Fitter, Electrician and COPA. </td>
              </tr>
              <tr>
                <td>2</td>
                <td>30/3/2021</td>
                <td>First year and outgoing batches of Fitter, Electrician and COPA. </td>
              </tr>
              <tr>
                <td>3</td>
                <td>31/3/2021</td>
                <td>First year and outgoing batches of Fitter, Electrician and COPA. </td>
              </tr>
              <tr>
                <td>4</td>
                <td>1/4/2021</td>
                <td>For outgoing batch students of various trades.</td>
              </tr>
              <tr>
                <td>5</td>
                <td>3/4/2021</td>
                <td>For outgoing batch students of various trades.</td>
              </tr>
              <tr>
                <td>6</td>
                <td>5/4/2021</td>
                <td>For outgoing batch students of various trades.</td>
              </tr>
              <tr>
                <td>7</td>
                <td>6/4/2021</td>
                <td>For outgoing batch students of various trades.</td>
              </tr>
              <tr>
                <td>8</td>
                <td>7/4/2021</td>
                <td>For outgoing batch students of various trades.</td>
              </tr>
              <tr>
                <td>9</td>
                <td>8/4/2021</td>
                <td>For outgoing batch students of various trades.</td>
              </tr>
              <tr>
                <td>10</td>
                <td>9/4/2021</td>
                <td>For outgoing batch students of various trades.</td>
              </tr>
              <tr>
                <td>11</td>
                <td>10/4/2021</td>
                <td>For outgoing batch students of various trades.</td>
              </tr>

            </table>
          </div> -->
    </div>
  </div>
</section>
<!--Content End-->

<style>
  footer {
    background: #ccc;
    color: #fff;
  }

  .row {
    margin-right: 0px;
    margin-left: 0px;
  }

  .header_cls {
    width: 100%;
    background-color: #fff;
    padding: 10px 0px;
  }

  .sticky {
    position: fixed;
    z-index: 11;
    box-shadow: 0px 3px 13px #000;
  }

  .menu_cls li {
    list-style-type: none;
    display: inline-block;
    padding: 5px 20px 10px 20px;
  }

  .menu_cls {
    text-align: right;
    padding: 20px 20px 0px;
    color: #000;
    font-size: 21px;
    font-weight: 600;
  }

  .menu_cls li a {
    color: #000;
  }

  .menu_cls li:hover,
  .menu_cls li:hover a {
    color: #fff;
    background: #2955a9;
    cursor: pointer;
    text-decoration: none;
  }

  .logo_cls img {
    width: 75px;
    padding: 0px 15px;
  }

  .banner>div {
    padding: 0px;
  }

  .footer_btm {
    background-color: #999;
    color: #fff;
  }

  .logo_cls {
    display: flex;
    align-items: flex-end;
  }

  .logo_sec img {
    width: 150px;
    margin: 0px 20px;
    padding: 5px;
  }

  .logo_sec {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 0px;
  }

  .footer_cls {
    padding: 40px 0px;
  }

  .footer_cls .col-md-3 {
    border-right: 3px solid #666;
  }

  .footer_cls .col-md-3:last-child {
    border-right: 0px solid #666;
  }

  .footer_cls h3 {
    color: #000;
    font-size: 21px;
    border-bottom: 2px solid #000;
    padding-bottom: 10px;
    width: fit-content;
  }

  .section_box_one {
    padding: 30px 0px;
  }

  .section_box_one h2 {
    border-bottom: 5px solid #000;
    padding-bottom: 5px;
    width: fit-content;
    margin: 0 auto 30px;
  }

  .footer_btm_rt {
    text-align: right;
  }

  .section_box_two {
    background-color: #2955a9;
    padding: 40px 0px;
    text-align: center;
    color: #fff;
    font-size: 18px;
  }

  .section_box_two h3 {
    font-size: 36px;
  }

  .click_here {
    background: #2955a9;
    padding: 5px 15px;
    color: #fff;
    font-size: 10px;
    font-weight: 500;
    border-radius: 10px;
    width: fit-content;
    cursor: pointer;
  }

  .click_here:hover {
    background-color: #000;
    text-decoration: none;
  }

  @media only screen and (max-width: 767px) {
    h2 {
      font-size: 24px;
      text-align: center;
    }
  }

  .ng_cls {
    height: 600px;
  }

  ::ng-deep .carousel-inner,
  ::ng-deep .carousel-item {
    height: 100% !important;
  }

  table {
    width: 100%;
  }

  th,
  td {
    padding: 10px;
  }

  thead {
    background-color: #d9dfe1;
  }

  tr:nth-child(odd) {
    background-color: #eee;
  }

  marquee {
    background: #fff;
    padding: 10px;
    color: #000;
  }

  .notifi_main {
    margin-top: 10px;
  }

  .notfication_cls {
    position: absolute;
    left: 15px;
    background: #2955a9;
    color: #fff;
    padding: 10px;
    animation-name: example;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    z-index: 1;
  }

  @keyframes example {
    from {
      background-color: #2955a9;
    }

    to {
      background-color: #000;
    }
  }
</style>
